import { Control, UseFormTrigger } from "react-hook-form";

import { TextInput } from "components/shared";
import { inputNome } from "_constants";

export const FormAddProject = ({
  control,
  trigger,
}: {
  control: Control<any>;
  trigger: UseFormTrigger<any>;
}) => {
  return (
    <div className="flex-column">
      <div className="width-100 margin-bottom-16">
        <TextInput
          control={control}
          name="name"
          placeholder={inputNome}
          maxLength={75}
          trigger={trigger}
          onlyLetters={false}
        />
      </div>
    </div>
  );
};
